import React, { useRef, useState } from 'react';
import Logo from "../Images/newlogo.svg";
import { Link } from 'react-router-dom';
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from 'react-bootstrap/Spinner';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import swal from 'sweetalert';

function ForgotPassword() {
  const emailRef = useRef();
  const [loading, setLoading] = useState(false);

  const auth = getAuth();

  const handleResetPassword = async () => {
    const email = emailRef.current.value;

    if (!email) {
      swal("Error", "Please enter your email address", "error");
      return;
    }

    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      swal("Success", "Password reset email sent! Check your inbox.", "success");
    } catch (error) {
      swal("Error", error.message, "error");
    }

    setLoading(false);
  };

  return (
    <div className='authPage'>
      <div className='authLeft'>
        <div className='authLeftBg'></div>
      </div>

      <div className='authRight'>
        <div className='authRightcont'>
          <Link to="/" className='authRightLogo'>
            <img src={Logo} alt="Logo" />
          </Link>
          <h1>Forgot Password</h1>
          <p>Enter your email address and we will send you a password reset link</p>
          <br/>

          <Form.Group className="mt-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              ref={emailRef}
            />
          </Form.Group>

          <div className='bottomBtnCont mt-4'>
            <Button
              onClick={handleResetPassword}
              variant="primary"
              className='btnLogin'
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  /> Sending...
                </>
              ) : (
                "Send Reset Link"
              )}
            </Button>
            <Link to="/login" className="mt-3 d-block text-center">
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;